import "core-js/modules/web.dom-collections.iterator.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "ya-wrapper-conter"
};
import YAHeader from './components/YAHeader';
import YAOrder from './components/YAOrder';
import YACommonLinks from './components/YACommonLinks';
import RecommendedAsins from '@/components/recommendedAsins/RecommendedAsins.vue';
import { ref, watch, onMounted, onUnmounted, computed, reactive } from 'vue';
import { useStore } from 'vuex';
import { Bridge } from '@/utils/bridge';
import { useRouter } from 'vue-router';
import { useLess } from '@/models/hooks';
import { getCandidates, getCustomerReview } from '@/models/api/yourOrderApi.js';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents, loadingEvents } from '@/configs/awsRumConfig';
import { useRecordLoadingEvent } from '@/models/hooks';
import { SET_AGENT_DATA } from '@/store/mutations.types';
import customerReviewConstants from '@/views/yourOrder/customerReview/constants.js';
const CANDIDATES_PAGE_SIZE = 1;
const CUSTOMER_REVIEW_PAGE_SIZE = 1;
export default {
  __name: 'YourAccount',
  setup(__props) {
    useLess('views/yourAccount/YourAccount.less');
    useRecordLoadingEvent(duration => ({
      ...loadingEvents.yourAccountPage.yourAccountPage,
      duration
    }));
    const router = useRouter();
    const isLogin = ref(false);
    const store = useStore();
    const customerReviewCount = reactive({
      commmentedCount: 0,
      toBeCommentedCount: 0
    });
    const {
      CUSTOMER_REVIEW_STATUS_ENUM
    } = customerReviewConstants;
    const distanceFromTop = computed(() => {
      var _store$state$navigato;
      return (_store$state$navigato = store.state.navigator.agentData) === null || _store$state$navigato === void 0 ? void 0 : _store$state$navigato.top;
    });
    const tabbarHeight = computed(() => {
      var _store$state$common$t;
      return (_store$state$common$t = store.state.common.tabbarHeight) !== null && _store$state$common$t !== void 0 ? _store$state$common$t : 0;
    });
    const getNumberOfComments = async () => {
      try {
        const result = await Promise.all([getCandidates({
          pageSize: CANDIDATES_PAGE_SIZE
        }), getCustomerReview({
          pageSize: CUSTOMER_REVIEW_PAGE_SIZE,
          status: CUSTOMER_REVIEW_STATUS_ENUM.REJECTED
        }), getCustomerReview({
          pageSize: CUSTOMER_REVIEW_PAGE_SIZE,
          status: CUSTOMER_REVIEW_STATUS_ENUM.VISIBLE
        })]);
        customerReviewCount.toBeCommentedCount = result[0].data.total + result[1].data.total;
        customerReviewCount.commmentedCount = result[2].data.total;
      } catch (error) {
        console.error(error);
      }
    };
    const checkIsLogIn = () => {
      // Is the user logged in
      Bridge.callFn('isAuthenticated', null, resultData => {
        isLogin.value = resultData === null || resultData === void 0 ? void 0 : resultData.result;
        if (isLogin.value) {
          getNumberOfComments();
        }
      });
    };
    const onAddToCartConfirm = () => {
      awsRumHandler.recordClickEvent(clickEvents.yourAccountPage.addToCartButton);
    };
    watch(() => router.currentRoute.value.name, newRouter => {
      if (newRouter === 'yourAccount') {
        checkIsLogIn();
      }
    }, {
      immediate: true
    });
    onMounted(() => {
      store.commit(`navigator/${SET_AGENT_DATA}`, {
        top: 0
      });
    });
    onUnmounted(() => {
      store.commit(`navigator/${SET_AGENT_DATA}`);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
        class: "ya-wrapper",
        style: _normalizeStyle({
          paddingTop: distanceFromTop.value + 'px'
        })
      }, [_createVNode(_unref(YAHeader), {
        isLogin: isLogin.value,
        "onUpdate:isLogin": _cache[0] || (_cache[0] = $event => isLogin.value = $event),
        customerReviewCount: customerReviewCount
      }, null, 8, ["isLogin", "customerReviewCount"]), _createElementVNode("div", _hoisted_1, [_createVNode(_unref(YAOrder), {
        isLogin: isLogin.value,
        "onUpdate:isLogin": _cache[1] || (_cache[1] = $event => isLogin.value = $event),
        toBeCommentedCount: customerReviewCount.toBeCommentedCount
      }, null, 8, ["isLogin", "toBeCommentedCount"]), _createVNode(_unref(YACommonLinks), {
        isLogin: isLogin.value,
        "onUpdate:isLogin": _cache[2] || (_cache[2] = $event => isLogin.value = $event)
      }, null, 8, ["isLogin"])])], 4), _createVNode(RecommendedAsins, {
        class: "ya-recommended-asins-area",
        onOnAddCartConfirm: onAddToCartConfirm,
        title: _ctx.$t('common.BEST_SELLING_ITEM_RECOMMENDATION'),
        style: _normalizeStyle({
          paddingBottom: tabbarHeight.value + 'px'
        })
      }, null, 8, ["title", "style"])], 64);
    };
  }
};